import { TranscationQuery, WebWorkerRequest, SelectQuery, RemoveQuery, CountQuery, UpdateQuery, InsertQuery } from "../../types";
import { Base } from "../base";
import * as Select from '../select/index';
import * as Count from '../count/index';
import * as Insert from '../insert/index';
import * as Remove from '../remove/index';
import * as Update from '../update/index';
import { API, ERROR_TYPE } from "../../enums";
import { QueryHelper } from "../query_helper";
import { IError } from "../../interfaces";
import { LogHelper } from "../../log_helper";
import { QueryExecutor } from "../../query_executor";
import { Util } from "../../util";
import { promise } from "../helpers/promise";

export class Instance extends Base {
    query: TranscationQuery;
    results;
    requestQueue: WebWorkerRequest[] = [];
    isQueryExecuting = false;

    isTxStarted_ = false;

    constructor(qry: TranscationQuery, onSuccess: (results: any) => void, onError: (err: IError) => void) {
        super();
        this.query = qry;
        this.onError = onError;
        this.onSuccess = onSuccess;
        this.results = {};
    }

    execute() {
        const notExistingTable = this.getNotExistingTable_(this.query.tables);
        if (notExistingTable != null) {
            this.onError(new LogHelper(ERROR_TYPE.TableNotExist, { tableName: notExistingTable }).get());
            return;
        }
        Promise.all(this.query.tables.map(table => {
            return Util.getAutoIncrementValues(this.getTable(table));
        })).then(results => {
            results.forEach((result, index) => {
                QueryHelper.autoIncrementValues[this.query.tables[index]] = result;
            });
            this.startExecution_();
        }).catch(this.onError);
    }

    private startExecution_() {
        const select = (qry: SelectQuery) => {
            return this.pushRequest_({
                name: API.Select,
                query: qry
            } as WebWorkerRequest);
        };
        const insert = (qry: InsertQuery) => {
            return this.pushRequest_({
                name: API.Insert,
                query: qry
            } as WebWorkerRequest);
        };
        const update = (qry: UpdateQuery) => {
            return this.pushRequest_({
                name: API.Update,
                query: qry
            } as WebWorkerRequest);
        };
        const remove = (qry: RemoveQuery) => {
            return this.pushRequest_({
                name: API.Remove,
                query: qry
            } as WebWorkerRequest);
        };
        const count = (qry: CountQuery) => {
            return this.pushRequest_({
                name: API.Count,
                query: qry
            } as WebWorkerRequest);
        };
        const setResult = (key: string, value) => {
            this.results[key] = value;
        };
        const getResult = (key: string) => {
            return this.results[key];
        };
        const abort = (msg: string) => {
            this.abortTransaction_(msg);
        };

        const start = () => {
            this.checkQueries_(this.requestQueue).then((results) => {
                this.startTransaction_();
            }).catch((err) => {
                this.onError(err);
            });
        }


        const txLogic = null;
        eval("txLogic =" + this.query.logic);
        txLogic.call(this, this.query.data);
        if (process.env.NODE_ENV === 'dev') {
            console.log(`transaction query started`);
        }
    }

    private startTransaction_() {
        try {
            this.isTxStarted_ = true;
            this.initTransaction_(this.query.tables);
            this.processExecutionOfQry_();
        }
        catch (ex) {
            this.errorOccured = true;
            this.onExceptionOccured(ex, { tableName: this.query.tables });
        }
    }

    private initTransaction_(tableNames: string[]) {
        this.createTransaction(tableNames, this.onTransactionCompleted_.bind(this));
    }

    private onTransactionCompleted_() {
        if (process.env.NODE_ENV === 'dev') {
            console.log(`transaction finished`);
        }
        this.onSuccess(this.results);
    }

    private onRequestFinished_(result) {
        const finisehdRequest = this.requestQueue.shift();
        if (process.env.NODE_ENV === 'dev') {
            console.log(`finished request : ${finisehdRequest.name} `);
        }
        if (finisehdRequest) {
            if (this.errorOccured === true) {
                this.abortTransaction_("automatic abort of transaction due to error occured");
                if (process.env.NODE_ENV === 'dev') {
                    console.log(`transaction aborted due to error occured`);
                }
                this.onErrorOccured(this.error);
            }
            else {
                this.isQueryExecuting = false;
                if (finisehdRequest.onSuccess) {
                    finisehdRequest.onSuccess(result);
                }
                this.processExecutionOfQry_();
            }
        }
    }

    private abortTransaction_(msg: string) {
        if (this.transaction != null) {
            this.transaction.abort();
            if (process.env.NODE_ENV === 'dev') {
                console.log(`transaction aborted. Msg : ${msg}`);
            }
        }
    }

    private executeRequest_(request: WebWorkerRequest) {
        this.isQueryExecuting = true;
        let requestObj;
        if (process.env.NODE_ENV === 'dev') {
            console.log(`executing request : ${request.name} `);
        }
        switch (request.name) {
            case API.Select:
                requestObj = new Select.Instance(
                    request.query, this.onRequestFinished_.bind(this), this.onError.bind(this)
                );
                break;
            case API.Insert:
                requestObj = new Insert.Instance(
                    request.query, this.onRequestFinished_.bind(this), this.onError.bind(this)
                );
                break;
            case API.Update:
                requestObj = new Update.Instance(
                    request.query, this.onRequestFinished_.bind(this), this.onError.bind(this)
                );
                break;
            case API.Remove:
                requestObj = new Remove.Instance(
                    request.query, this.onRequestFinished_.bind(this), this.onError.bind(this)
                );
                break;
            case API.Count:
                requestObj = new Count.Instance(
                    request.query, this.onRequestFinished_.bind(this), this.onError.bind(this)
                );
                break;
        }
        requestObj.isTransaction = true;
        requestObj.execute();
    }

    private pushRequest_(request: WebWorkerRequest) {
        const push = () => {
            this.requestQueue.push(request);
        };
        const promise = new Promise((resolve, reject) => {
            request.onSuccess = (result) => {
                resolve(result);
            };
            request.onError = (error) => {
                this.errorOccured = true;
                this.error = error;
                reject(error);
            };
        });
        if (this.isTxStarted_ === true) {
            this.checkQueries_([request]).then(() => {
                push();
                this.processExecutionOfQry_();
            }).catch(err => {
                this.errorOccured = true;
                this.abortTransaction_(JSON.stringify(err));
            });
        }
        else {
            push();
        }
        if (process.env.NODE_ENV === 'dev') {
            console.log(`request pushed : ${request.name} with query value - ${JSON.stringify(request.query)}`);
        }
        return promise;
    }

    private processExecutionOfQry_() {
        if (this.requestQueue.length > 0 && this.isQueryExecuting === false) {
            this.executeRequest_(this.requestQueue[0]);
        }
    }

    private checkQueries_(requestQueue: WebWorkerRequest[]) {
        return Promise.all(requestQueue.map(request => {
            const tableName = request.query.into || request.query.in;
            return new QueryHelper(request.name, request.query).checkAndModify(

            )
        }));
    }

    private getNotExistingTable_(tables: string[]) {
        let invalidTable: string = null;
        tables.every(table => {
            if (this.isTableExist(table) === false) {
                invalidTable = table;
                return false;
            }
            return true;
        });
        return invalidTable;
    }
}